import React from "react";

const CatalogHeader = ({groups, currentGroupId, onClick}) => {
  const divItems = groups
    .map(g => 
      <div id={`group-${g.id}`} className={"catalog-mob-header-item" + (currentGroupId === g.id ? " catalog-mob-header-selected" : "")} onClick={() => onClick(g.id)} key={g.id}>
          {g.name}
      </div>)

  return<div className='catalog-mob-header' id={'group-header'}>
    {divItems}
  </div>
}

export default CatalogHeader;